// Per-attempt deadline for ordinary HTTP requests. SSE streams are excluded.
// 60,000 ms = 60 seconds
export const HTTP_REQUEST_TIMEOUT_MS = 60_000;
